export default __webpack_public_path__ + "static/media/mark-icon.e435b388.png";